export default "__VITE_ASSET__12a1e5e0__"